import { useScopeSetup } from "@/hooks/useScope";

import { memo } from "react";

export const Scope = memo(function Scope({
  children,
}: {
  children: React.ReactNode;
}) {
  useScopeSetup();
  return <>{children}</>;
});
